import { useEffect, useState } from 'react';
import API from '../api';
import toast from 'react-hot-toast';

// slip_v1: Bank list ของไทย
const TH_BANKS = [
  { code: 'KBANK', name: 'กสิกรไทย', color: '#138f2d' },
  { code: 'SCB', name: 'ไทยพาณิชย์', color: '#4e2d7f' },
  { code: 'BBL', name: 'กรุงเทพ', color: '#1e4d9a' },
  { code: 'KTB', name: 'กรุงไทย', color: '#00aff0' },
  { code: 'BAY', name: 'กรุงศรีอยุธยา', color: '#fec43b' },
  { code: 'TTB', name: 'ทหารไทยธนชาต', color: '#1279be' },
  { code: 'GSB', name: 'ออมสิน', color: '#eb198d' },
  { code: 'BAAC', name: 'ธ.ก.ส.', color: '#4ca64c' },
  { code: 'KKP', name: 'เกียรตินาคินภัทร', color: '#0050a0' },
  { code: 'CIMB', name: 'ซีไอเอ็มบี', color: '#7a1f3d' },
  { code: 'TCRB', name: 'ไทยเครดิต', color: '#0f7350' },
  { code: 'UOB', name: 'ยูโอบี', color: '#003da6' },
  { code: 'LH', name: 'แลนด์ แอนด์ เฮ้าส์', color: '#54b948' },
  { code: 'TISCO', name: 'ทิสโก้', color: '#0050a0' },
  { code: 'OTHER', name: 'อื่นๆ', color: '#64748b' },
];

export default function Settings() {
  const [license, setLicense] = useState(null);
  const [pwForm, setPwForm] = useState({ current_password: '', new_password: '', confirm_password: '' });
  const [pwLoading, setPwLoading] = useState(false);
  const user = JSON.parse(localStorage.getItem('tenant') || '{}');
  const isAgent = user.role === 'agent' || user.role === 'staff' || user.role === 'admin' || user.role === 'viewer';

  useEffect(() => {
    API.get('/api/tenants/me').then(r => {
      setLicense(r.data.license);
    });
  }, []);

  const changePassword = async (e) => {
    e.preventDefault();
    if (pwForm.new_password !== pwForm.confirm_password) { toast.error('รหัสผ่านใหม่ไม่ตรงกัน'); return; }
    if (pwForm.new_password.length < 6) { toast.error('รหัสผ่านใหม่ต้องมีอย่างน้อย 6 ตัวอักษร'); return; }
    setPwLoading(true);
    try {
      const endpoint = isAgent ? '/api/agents/change-password' : '/api/auth/change-password';
      await API.put(endpoint, { current_password: pwForm.current_password, new_password: pwForm.new_password });
      toast.success('เปลี่ยนรหัสผ่านสำเร็จ');
      setPwForm({ current_password: '', new_password: '', confirm_password: '' });
    } catch(err) { toast.error(err.response?.data?.error || 'เกิดข้อผิดพลาด'); }
    setPwLoading(false);
  };


  const daysLeft = license ? Math.ceil((new Date(license.expires_at) - new Date()) / 86400000) : 0;

  // slip_v1 state
  const [slipLoaded, setSlipLoaded] = useState(false);
  const [slipSettings, setSlipSettings] = useState({ has_token:false, token_preview:'', mode:'manual' });
  const [slipQuota, setSlipQuota] = useState(null); // slip_quota_v1
  const [slipForm, setSlipForm] = useState({ slip2go_token:'', slip_verify_mode:'manual', slip_match_account_required: true, slip_auto_reply:false, slip_reply_minutes:5 }); /* slip_triage_v1 */
  const [slipSaving, setSlipSaving] = useState(false);
  /* slip_topup_v1 */
  const [slipBuyOpen, setSlipBuyOpen] = useState(false);
  const [slipPkgs, setSlipPkgs] = useState([]);
  const [slipBuyPkg, setSlipBuyPkg] = useState(null);
  const [slipBuyFile, setSlipBuyFile] = useState(null);
  const [slipBuying, setSlipBuying] = useState(false);
  const [slipOrders, setSlipOrders] = useState([]);
  const [bankAccounts, setBankAccounts] = useState([]);
  const [bankModal, setBankModal] = useState(false);
  const [bankEdit, setBankEdit] = useState(null);
  const [bankSaving, setBankSaving] = useState(false);

  useEffect(() => {
    (async () => {
      try {
        const [s, b, q] = await Promise.all([
          API.get('/api/slip-verify/settings'),
          API.get('/api/bank-accounts'),
          API.get('/api/slip-verify/quota'),  // slip_quota_v1
        ]);
        setSlipSettings(s.data);
        setSlipForm({ slip2go_token:'', slip_verify_mode: s.data.mode || 'manual', slip_match_account_required: s.data.slip_match_account_required !== false, slip_auto_reply: s.data.slip_auto_reply === true, slip_reply_minutes: s.data.slip_reply_minutes || 5 }); /* slip_triage_v1 */
        setBankAccounts(b.data);
        setSlipQuota(q.data);
        setSlipLoaded(true);
      } catch (e) { setSlipLoaded(true); }
    })();
  }, []);

  /* slip_topup_v1: buy extra slip quota */
  const openSlipBuy = async () => {
    setSlipBuyOpen(true); setSlipBuyPkg(null); setSlipBuyFile(null);
    try {
      const [p, o] = await Promise.all([
        API.get('/api/slip-verify/packages'),
        API.get('/api/slip-verify/my-orders'),
      ]);
      setSlipPkgs(p.data); setSlipOrders(o.data);
    } catch (e) { toast.error('โหลดแพ็กเกจไม่สำเร็จ'); }
  };
  const submitSlipBuy = async () => {
    if (!slipBuyPkg) return toast.error('กรุณาเลือกแพ็กเกจ');
    if (!slipBuyFile) return toast.error('กรุณาอัปโหลดสลิปการโอน');
    setSlipBuying(true);
    try {
      const fd = new FormData();
      fd.append('package_id', slipBuyPkg.id); fd.append('slip', slipBuyFile);
      await API.post('/api/slip-verify/buy', fd);
      toast.success('ส่งคำสั่งซื้อแล้ว รอแอดมินอนุมัติ');
      setSlipBuyPkg(null); setSlipBuyFile(null);
      const o = await API.get('/api/slip-verify/my-orders'); setSlipOrders(o.data);
    } catch (e) { toast.error(e.response?.data?.error || 'ซื้อไม่สำเร็จ'); }
    setSlipBuying(false);
  };
  const saveSlipSettings = async () => {
    setSlipSaving(true);
    try {
      const body = { slip_verify_mode: slipForm.slip_verify_mode, slip_match_account_required: slipForm.slip_match_account_required, slip_auto_reply: slipForm.slip_auto_reply, slip_reply_minutes: slipForm.slip_reply_minutes }; /* slip_triage_v1 */
      if (slipForm.slip2go_token) body.slip2go_token = slipForm.slip2go_token;
      await API.put('/api/slip-verify/settings', body);
      const s = await API.get('/api/slip-verify/settings');
      setSlipSettings(s.data);
      setSlipForm({ slip2go_token:'', slip_verify_mode: s.data.mode, slip_match_account_required: s.data.slip_match_account_required !== false, slip_auto_reply: s.data.slip_auto_reply === true, slip_reply_minutes: s.data.slip_reply_minutes || 5 }); /* slip_triage_v1 */
      alert('บันทึกการตั้งค่าเรียบร้อย');
    } catch (e) { alert(e.response?.data?.error || e.message); }
    setSlipSaving(false);
  };

  const saveBankAccount = async () => {
    if (!bankEdit.account_number || !bankEdit.account_name) {
      alert('กรุณากรอกเลขบัญชีและชื่อบัญชี');
      return;
    }
    setBankSaving(true);
    try {
      if (bankEdit.id) {
        await API.put(`/api/bank-accounts/${bankEdit.id}`, bankEdit);
      } else {
        await API.post('/api/bank-accounts', bankEdit);
      }
      const b = await API.get('/api/bank-accounts');
      setBankAccounts(b.data);
      setBankModal(false);
    } catch (e) { alert(e.response?.data?.error || e.message); }
    setBankSaving(false);
  };

  const deleteBankAccount = async (id) => {
    if (!window.confirm('ลบบัญชีนี้?')) return;
    try {
      await API.delete(`/api/bank-accounts/${id}`);
      const b = await API.get('/api/bank-accounts');
      setBankAccounts(b.data);
    } catch (e) { alert(e.response?.data?.error || e.message); }
  };

  return (
    <div style={{ padding: '24px 28px', background: '#f8fafc', minHeight: '100vh' }}>
      <h2 style={{ fontSize: 22, fontWeight: 700, marginBottom: 24, color: '#1e293b' }}>⚙️ Settings</h2>

      {/* License Info */}
      {license && (
        <div style={{ background: daysLeft < 7 ? '#fef2f2' : '#f0fdf4', border: '1px solid ' + (daysLeft < 7 ? '#ef4444' : '#22c55e'), borderRadius: 12, padding: 16, marginBottom: 24 }}>
          <p style={{ color: daysLeft < 7 ? '#ef4444' : '#16a34a', fontWeight: 600, margin: 0 }}>
            {daysLeft < 7 ? '⚠️' : '✅'} License: <strong>{license.plan}</strong> — เหลือ {daysLeft} วัน (หมด {new Date(license.expires_at).toLocaleDateString('th-TH')})
          </p>
          <div style={{ display: 'flex', gap: 24, marginTop: 10, fontSize: 13, color: '#64748b' }}>
            <span>📡 Social: {license.max_channels} บัญชี</span>
            <span>👤 Admin: {license.max_agents} คน</span>
            <span>🤖 KB: {license.max_kb} หัวข้อ</span>
          </div>
        </div>
      )}

      {/* Change Password - แสดงเฉพาะ agent */}
      {(
        <div style={{ background:'#fff', borderRadius:12, padding:24, boxShadow:'0 1px 6px rgba(0,0,0,0.07)', marginBottom:24 }}>
          <h3 style={{ marginBottom:4, fontWeight:600, color:'#1e293b' }}>🔑 เปลี่ยนรหัสผ่าน</h3>
          <p style={{ color:'#64748b', fontSize:13, marginBottom:20 }}>เปลี่ยนรหัสผ่านสำหรับเข้าสู่ระบบ</p>
          <form onSubmit={changePassword}>
            <div style={{ marginBottom:14 }}>
              <label style={{ color:'#64748b', fontSize:13, display:'block', marginBottom:6 }}>รหัสผ่านเดิม</label>
              <input type="password" value={pwForm.current_password} onChange={e => setPwForm({...pwForm, current_password:e.target.value})}
                placeholder="รหัสผ่านปัจจุบัน"
                style={{ width:'100%', padding:'10px 14px', borderRadius:8, border:'1px solid #e2e8f0', fontSize:14, boxSizing:'border-box' }} required />
            </div>
            <div style={{ marginBottom:14 }}>
              <label style={{ color:'#64748b', fontSize:13, display:'block', marginBottom:6 }}>รหัสผ่านใหม่</label>
              <input type="password" value={pwForm.new_password} onChange={e => setPwForm({...pwForm, new_password:e.target.value})}
                placeholder="อย่างน้อย 6 ตัวอักษร"
                style={{ width:'100%', padding:'10px 14px', borderRadius:8, border:'1px solid #e2e8f0', fontSize:14, boxSizing:'border-box' }} required />
            </div>
            <div style={{ marginBottom:20 }}>
              <label style={{ color:'#64748b', fontSize:13, display:'block', marginBottom:6 }}>ยืนยันรหัสผ่านใหม่</label>
              <input type="password" value={pwForm.confirm_password} onChange={e => setPwForm({...pwForm, confirm_password:e.target.value})}
                placeholder="พิมพ์รหัสผ่านใหม่อีกครั้ง"
                style={{ width:'100%', padding:'10px 14px', borderRadius:8, border:'1px solid #e2e8f0', fontSize:14, boxSizing:'border-box' }} required />
            </div>
            <button type="submit" disabled={pwLoading}
              style={{ background:'#0ea5e9', color:'#fff', border:'none', borderRadius:8, padding:'10px 24px', fontSize:14, fontWeight:600, cursor:'pointer' }}>
              {pwLoading ? 'กำลังบันทึก...' : 'เปลี่ยนรหัสผ่าน'}
            </button>
          </form>
        </div>
      )}

      {/* slip_v1: Slip2Go Token + Mode */}
      {slipLoaded && (
        <div style={{ background:'#fff', borderRadius:12, padding:24, boxShadow:'0 1px 6px rgba(0,0,0,0.07)', marginBottom:24 }}>
          <h3 style={{ marginBottom:4, fontWeight:600, color:'#1e293b' }}>💳 ตรวจสลิปอัตโนมัติ (Slip2Go)</h3>
          <p style={{ color:'#64748b', fontSize:13, marginBottom:20 }}>เชื่อมต่อ Slip2Go เพื่อตรวจสลิปลูกค้า</p>

          {/* global_token_v1: ลบ input token — แสดง status indicator แทน */}
          <div style={{ marginBottom:18 }}>
            {slipSettings.has_token ? (
              <div style={{
                display:'flex', alignItems:'center', gap:10,
                padding:'12px 14px',
                background:'#f0fdf4', border:'1px solid #bbf7d0',
                borderRadius:8, fontSize:13,
              }}>
                <span style={{ fontSize:18 }}>✅</span>
                <div>
                  <div style={{ fontWeight:600, color:'#166534' }}>Slip2Go พร้อมใช้งาน</div>
                  <div style={{ color:'#15803d', fontSize:11, marginTop:2 }}>
                    🔐 Token จัดการโดย Super Admin
                  </div>
                </div>
              </div>
            ) : (
              <div style={{
                display:'flex', alignItems:'center', gap:10,
                padding:'12px 14px',
                background:'#fef2f2', border:'1px solid #fecaca',
                borderRadius:8, fontSize:13,
              }}>
                <span style={{ fontSize:18 }}>⚠️</span>
                <div>
                  <div style={{ fontWeight:600, color:'#991b1b' }}>ยังไม่พร้อมใช้งาน</div>
                  <div style={{ color:'#dc2626', fontSize:11, marginTop:2 }}>
                    Super Admin ยังไม่ได้ตั้งค่า Token — กรุณาติดต่อผู้ดูแลระบบ
                  </div>
                </div>
              </div>
            )}
          </div>

          <div style={{ marginBottom:20 }}>
            <label style={{ color:'#64748b', fontSize:13, display:'block', marginBottom:8 }}>โหมดตรวจสลิป</label>
            {[
              { val:'off', label:'⛔ ปิดใช้งาน', desc:'ไม่แสดงปุ่มตรวจสลิป' },
              { val:'manual', label:'👤 ตรวจ Manual', desc:'Agent กดปุ่ม "ตรวจสลิป" เอง (แนะนำ)' },
              { val:'auto', label:'⚡ ตรวจอัตโนมัติ', desc:'ลูกค้าส่งรูป → ระบบตรวจทันที (ใช้โควต้าทุกรูป)' },
            ].map(opt => (
              <label key={opt.val} style={{ display:'flex', alignItems:'flex-start', gap:10, padding:'10px 12px', marginBottom:6, border:'1px solid', borderColor: slipForm.slip_verify_mode===opt.val ? '#0ea5e9' : '#e2e8f0', borderRadius:8, cursor:'pointer', background: slipForm.slip_verify_mode===opt.val ? '#f0f9ff' : '#fff' }}>
                <input type="radio" checked={slipForm.slip_verify_mode===opt.val}
                  onChange={() => setSlipForm({...slipForm, slip_verify_mode: opt.val})}
                  style={{ marginTop:3 }} />
                <div>
                  <div style={{ fontWeight:600, fontSize:14, color:'#1e293b' }}>{opt.label}</div>
                  <div style={{ fontSize:12, color:'#64748b', marginTop:2 }}>{opt.desc}</div>
                </div>
              </label>
            ))}
          </div>

          <div style={{ marginBottom:20, padding:'14px 16px', background:'#f8fafc', borderRadius:8, border:'1px solid #e2e8f0' }}>
            <label style={{ display:'flex', alignItems:'flex-start', gap:12, cursor:'pointer' }}>
              <input type="checkbox" checked={slipForm.slip_match_account_required}
                onChange={(e) => setSlipForm({...slipForm, slip_match_account_required: e.target.checked})}
                style={{ marginTop:3, width:18, height:18, cursor:'pointer' }} />
              <div style={{ flex:1 }}>
                <div style={{ fontWeight:600, fontSize:14, color:'#1e293b' }}>
                  🔒 จับคู่บัญชีรับเงิน (แนะนำ)
                </div>
                <div style={{ fontSize:12, color:'#64748b', marginTop:4, lineHeight:1.6 }}>
                  {slipForm.slip_match_account_required
                    ? 'ระบบจะตรวจว่าสลิปโอนเข้าบัญชีของร้านจริงไหม — ป้องกันสลิปปลอม/บัญชีอื่น'
                    : '⚠️ ระบบจะตรวจเฉพาะข้อมูลสลิป (ของ Slip2Go) — ไม่จับคู่บัญชี'}
                </div>
                {slipForm.slip_match_account_required && bankAccounts.length === 0 && (
                  <div style={{ marginTop:8, padding:'8px 12px', background:'#fef3c7', borderRadius:6, fontSize:12, color:'#92400e' }}>
                    ⚠️ ยังไม่ได้เพิ่มบัญชีรับเงิน — เลื่อนลงไปเพิ่มบัญชีก่อนใช้งาน หรือปิดตัวเลือกนี้
                  </div>
                )}
              </div>
            </label>
          </div>

          {slipForm.slip_verify_mode === 'auto' && (
            <div style={{ marginBottom:20, padding:'14px 16px', background:'#f0fdf4', borderRadius:8, border:'1px solid #bbf7d0' }}>
              <label style={{ display:'flex', alignItems:'flex-start', gap:12, cursor:'pointer' }}>
                <input type="checkbox" checked={slipForm.slip_auto_reply}
                  onChange={(e) => setSlipForm({...slipForm, slip_auto_reply: e.target.checked})}
                  style={{ marginTop:3, width:18, height:18, cursor:'pointer' }} />
                <div style={{ flex:1 }}>
                  <div style={{ fontWeight:600, fontSize:14, color:'#1e293b' }}>💬 ตอบลูกค้าอัตโนมัติหลังตรวจสลิป</div>
                  <div style={{ fontSize:12, color:'#64748b', marginTop:4, lineHeight:1.6 }}>
                    ลูกค้าส่งสลิป → บอทตอบทันที เช่น "รับสลิปแล้ว ยอด X กำลังเติมให้ ภายใน N นาที" (ฟรี ไม่กินโควตา LINE) · เคสยอด/บัญชีไม่ตรง หรือสลิปซ้ำ จะแจ้งแอดมินอัตโนมัติ · AI จะไม่ตอบซ้ำรูปสลิป
                  </div>
                  {slipForm.slip_auto_reply && (
                    <div style={{ marginTop:8, fontSize:13, color:'#374151' }}>
                      แจ้งลูกค้าว่าเติมภายใน
                      <input type="number" min="1" max="60" value={slipForm.slip_reply_minutes}
                        onClick={(e) => e.stopPropagation()}
                        onChange={(e) => setSlipForm({...slipForm, slip_reply_minutes: e.target.value})}
                        style={{ width:56, margin:'0 6px', padding:'4px 8px', border:'1px solid #cbd5e1', borderRadius:6 }} />
                      นาที
                    </div>
                  )}
                </div>
              </label>
            </div>
          )}

          <button onClick={saveSlipSettings} disabled={slipSaving}
            style={{ background:'#0ea5e9', color:'#fff', border:'none', borderRadius:8, padding:'10px 24px', fontSize:14, fontWeight:600, cursor:'pointer' }}>
            {slipSaving ? 'กำลังบันทึก...' : '💾 บันทึก'}
          </button>
        </div>
      )}

      {/* slip_quota_v1: Quota Usage */}
      {slipLoaded && slipQuota && (
        <div style={{ background:'#fff', borderRadius:12, padding:24, boxShadow:'0 1px 6px rgba(0,0,0,0.07)', marginBottom:24 }}>
          <div style={{ display:'flex', justifyContent:'space-between', alignItems:'flex-start', marginBottom:14 }}>
            <div>
              <h3 style={{ margin:0, fontWeight:600, color:'#1e293b' }}>📊 โควต้าตรวจสลิปรายเดือน</h3>
              <p style={{ color:'#64748b', fontSize:13, margin:'4px 0 0' }}>
                ใช้ฟรี {slipQuota.monthly} ครั้ง/เดือน — รีเซ็ตทุก 1 เดือนตามรอบของคุณ
              </p>
            </div>
            <div style={{ textAlign:'right' }}>
              <div style={{ fontSize:24, fontWeight:700, color: slipQuota.percent >= 100 ? '#dc2626' : slipQuota.percent >= 80 ? '#f59e0b' : '#0f172a' }}>
                {slipQuota.used}<span style={{ fontSize:16, color:'#94a3b8', fontWeight:400 }}>/{slipQuota.total}</span>
              </div>
              <div style={{ fontSize:11, color:'#94a3b8' }}>เหลือ {slipQuota.remaining} ครั้ง</div>
            </div>
          </div>

          {/* Progress bar */}
          <div style={{ background:'#e2e8f0', height:10, borderRadius:5, overflow:'hidden', marginBottom:10 }}>
            <div style={{
              width: `${Math.min(100, slipQuota.percent)}%`,
              height: '100%',
              background: slipQuota.percent >= 100 ? '#dc2626' : slipQuota.percent >= 80 ? '#f59e0b' : '#22c55e',
              transition: 'width 0.3s',
            }} />
          </div>

          <div style={{ display:'flex', justifyContent:'space-between', fontSize:12, color:'#64748b' }}>
            <span>📅 รีเซ็ตอีก {slipQuota.days_until_reset} วัน ({slipQuota.next_reset})</span>
            {slipQuota.topup > 0 && <span>+ Top-up: {slipQuota.topup}</span>}
          </div>

          {slipQuota.percent >= 100 && (
            <div style={{ marginTop:12, padding:'10px 14px', background:'#fee2e2', borderRadius:8, color:'#991b1b', fontSize:13 }}>
              ⛔ <strong>โควต้าหมดแล้ว</strong> — สลิปลูกค้าจะไม่ถูกตรวจ กดปุ่มด้านล่างเพื่อซื้อเพิ่ม
            </div>
          )}
          {/* slip_topup_v1: buy more */}
          <button onClick={openSlipBuy} style={{ marginTop:14, width:'100%', background: slipQuota.percent >= 80 ? '#f59e0b' : '#0ea5e9', color:'#fff', border:'none', borderRadius:8, padding:'11px', fontSize:14, fontWeight:700, cursor:'pointer' }}>
            🧾 ซื้อสลิปเพิ่ม
          </button>
        </div>
      )}

      {/* slip_topup_v1: buy slip quota modal */}
      {slipBuyOpen && (
        <div onClick={() => setSlipBuyOpen(false)} style={{ position:'fixed', inset:0, background:'rgba(0,0,0,0.5)', display:'flex', alignItems:'center', justifyContent:'center', zIndex:1000, padding:16 }}>
          <div onClick={(e) => e.stopPropagation()} style={{ background:'#fff', borderRadius:14, padding:24, maxWidth:460, width:'100%', maxHeight:'90vh', overflowY:'auto' }}>
            <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:16 }}>
              <h3 style={{ margin:0, fontWeight:700, color:'#1e293b' }}>🧾 ซื้อสลิปเพิ่ม</h3>
              <button onClick={() => setSlipBuyOpen(false)} style={{ background:'none', border:'none', fontSize:22, cursor:'pointer', color:'#94a3b8' }}>×</button>
            </div>
            <p style={{ color:'#64748b', fontSize:13, marginTop:0, marginBottom:16 }}>เลือกแพ็ก → โอนเงินตามยอด → อัปสลิปการโอน → รอแอดมินอนุมัติ ระบบจะเติมโควต้าให้อัตโนมัติ</p>
            {slipPkgs.length === 0 && <div style={{ color:'#94a3b8', fontSize:13, marginBottom:12 }}>ยังไม่มีแพ็กเกจให้ซื้อ</div>}
            {slipPkgs.map(p => {
              const total = Number(p.slips) + Number(p.bonus_slips || 0);
              const sel = slipBuyPkg && slipBuyPkg.id === p.id;
              return (
                <label key={p.id} style={{ display:'flex', alignItems:'center', gap:12, padding:'12px 14px', marginBottom:8, border:'2px solid', borderColor: sel ? '#0ea5e9' : '#e2e8f0', borderRadius:10, cursor:'pointer', background: sel ? '#f0f9ff' : '#fff' }}>
                  <input type="radio" checked={sel} onChange={() => setSlipBuyPkg(p)} />
                  <div style={{ flex:1 }}>
                    <div style={{ fontWeight:600, color:'#1e293b' }}>{p.name}</div>
                    <div style={{ fontSize:12, color:'#64748b' }}>{total.toLocaleString()} สลิป{Number(p.bonus_slips)>0 ? ' (รวมโบนัส ' + Number(p.bonus_slips).toLocaleString() + ')' : ''}</div>
                  </div>
                  <div style={{ fontWeight:700, color:'#0ea5e9' }}>฿{Number(p.price_thb).toLocaleString()}</div>
                </label>
              );
            })}
            <div style={{ marginTop:14 }}>
              <label style={{ fontSize:13, color:'#64748b', display:'block', marginBottom:6 }}>อัปโหลดสลิปการโอน</label>
              <input type="file" accept="image/*,.pdf" onChange={(e) => setSlipBuyFile(e.target.files[0])} style={{ fontSize:13 }} />
            </div>
            <button onClick={submitSlipBuy} disabled={slipBuying} style={{ marginTop:16, width:'100%', background:'#22c55e', color:'#fff', border:'none', borderRadius:8, padding:'11px', fontSize:14, fontWeight:700, cursor: slipBuying ? 'wait' : 'pointer', opacity: slipBuying ? 0.6 : 1 }}>
              {slipBuying ? 'กำลังส่ง...' : 'ยืนยันคำสั่งซื้อ'}
            </button>
            {slipOrders.length > 0 && (
              <div style={{ marginTop:18 }}>
                <div style={{ fontSize:13, fontWeight:600, color:'#1e293b', marginBottom:8 }}>ประวัติคำสั่งซื้อ</div>
                {slipOrders.map(o => (
                  <div key={o.id} style={{ display:'flex', justifyContent:'space-between', fontSize:12, padding:'6px 0', borderBottom:'1px solid #f1f5f9' }}>
                    <span style={{ color:'#475569' }}>{o.package_name} · {Number(o.slips_granted||0).toLocaleString()} สลิป</span>
                    <span style={{ fontWeight:600, color: o.status==='approved' ? '#16a34a' : o.status==='rejected' ? '#dc2626' : '#f59e0b' }}>
                      {o.status==='approved' ? '✅ อนุมัติ' : o.status==='rejected' ? '❌ ปฏิเสธ' : '⏳ รออนุมัติ'}
                    </span>
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>
      )}

      {/* slip_v1: Bank Accounts */}
      {slipLoaded && (
        <div style={{ background:'#fff', borderRadius:12, padding:24, boxShadow:'0 1px 6px rgba(0,0,0,0.07)', marginBottom:24 }}>
          <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:16 }}>
            <div>
              <h3 style={{ margin:0, fontWeight:600, color:'#1e293b' }}>🏦 บัญชีรับเงิน</h3>
              <p style={{ color:'#64748b', fontSize:13, margin:'4px 0 0' }}>เพิ่มบัญชีของร้าน — ระบบจะเทียบกับสลิปที่ตรวจ</p>
            </div>
            <button onClick={() => { setBankEdit({ bank_code:'KBANK', account_number:'', account_name:'', branch:'', is_primary: bankAccounts.length===0, note:'' }); setBankModal(true); }}
              style={{ background:'#22c55e', color:'#fff', border:'none', borderRadius:8, padding:'8px 14px', fontSize:13, fontWeight:600, cursor:'pointer' }}>
              + เพิ่มบัญชี
            </button>
          </div>

          {bankAccounts.length === 0 ? (
            <div style={{ padding:24, textAlign:'center', background:'#f8fafc', borderRadius:8, color:'#64748b', fontSize:13 }}>
              ยังไม่มีบัญชีรับเงิน — กดปุ่ม "เพิ่มบัญชี" เพื่อเริ่ม
            </div>
          ) : (
            <div style={{ display:'flex', flexDirection:'column', gap:8 }}>
              {bankAccounts.map(b => {
                const bank = TH_BANKS.find(x => x.code === b.bank_code) || TH_BANKS[TH_BANKS.length-1];
                return (
                  <div key={b.id} style={{ display:'flex', alignItems:'center', gap:12, padding:'12px 14px', border:'1px solid #e2e8f0', borderRadius:8 }}>
                    <div style={{ width:40, height:40, borderRadius:8, background: bank.color+'20', color: bank.color, display:'flex', alignItems:'center', justifyContent:'center', fontWeight:700, fontSize:13, flexShrink:0 }}>
                      {bank.code === 'OTHER' ? '🏦' : bank.name.slice(0,2)}
                    </div>
                    <div style={{ flex:1, minWidth:0 }}>
                      <div style={{ display:'flex', alignItems:'center', gap:8 }}>
                        <span style={{ fontWeight:600, color:'#1e293b' }}>{bank.name}</span>
                        {b.is_primary && <span style={{ background:'#fef3c7', color:'#92400e', padding:'1px 6px', borderRadius:4, fontSize:10, fontWeight:600 }}>⭐ บัญชีหลัก</span>}
                        {!b.is_active && <span style={{ background:'#fee2e2', color:'#991b1b', padding:'1px 6px', borderRadius:4, fontSize:10, fontWeight:600 }}>ปิดใช้งาน</span>}
                      </div>
                      <div style={{ fontSize:13, color:'#475569', fontFamily:'monospace', marginTop:2 }}>{b.account_number}</div>
                      <div style={{ fontSize:12, color:'#64748b' }}>{b.account_name}{b.branch ? ` • ${b.branch}` : ''}</div>
                    </div>
                    <button onClick={() => { setBankEdit({ ...b }); setBankModal(true); }}
                      style={{ background:'transparent', color:'#0ea5e9', border:'1px solid #0ea5e9', borderRadius:6, padding:'4px 10px', fontSize:12, cursor:'pointer' }}>แก้ไข</button>
                    <button onClick={() => deleteBankAccount(b.id)}
                      style={{ background:'transparent', color:'#dc2626', border:'1px solid #dc2626', borderRadius:6, padding:'4px 10px', fontSize:12, cursor:'pointer' }}>ลบ</button>
                  </div>
                );
              })}
            </div>
          )}
        </div>
      )}

      {/* slip_v1: Bank Account Edit Modal */}
      {bankModal && bankEdit && (
        <div onClick={() => setBankModal(false)} style={{ position:'fixed', inset:0, background:'rgba(15,23,42,0.5)', zIndex:9999, display:'flex', alignItems:'center', justifyContent:'center', padding:20 }}>
          <div onClick={e => e.stopPropagation()} style={{ background:'#fff', borderRadius:14, padding:24, maxWidth:480, width:'100%', maxHeight:'90vh', overflowY:'auto' }}>
            <h3 style={{ margin:'0 0 16px', color:'#1e293b' }}>{bankEdit.id ? 'แก้ไข' : 'เพิ่ม'}บัญชีรับเงิน</h3>

            <div style={{ marginBottom:12 }}>
              <label style={{ color:'#64748b', fontSize:13, display:'block', marginBottom:6 }}>ธนาคาร</label>
              <select value={bankEdit.bank_code}
                onChange={e => setBankEdit({...bankEdit, bank_code:e.target.value})}
                style={{ width:'100%', padding:'10px 14px', borderRadius:8, border:'1px solid #e2e8f0', fontSize:14, boxSizing:'border-box' }}>
                {TH_BANKS.map(b => <option key={b.code} value={b.code}>{b.name}</option>)}
              </select>
            </div>

            <div style={{ marginBottom:12 }}>
              <label style={{ color:'#64748b', fontSize:13, display:'block', marginBottom:6 }}>เลขบัญชี *</label>
              <input type="text" value={bankEdit.account_number}
                onChange={e => setBankEdit({...bankEdit, account_number:e.target.value})}
                placeholder="123-4-56789-0"
                style={{ width:'100%', padding:'10px 14px', borderRadius:8, border:'1px solid #e2e8f0', fontSize:14, boxSizing:'border-box', fontFamily:'monospace' }} />
            </div>

            <div style={{ marginBottom:12 }}>
              <label style={{ color:'#64748b', fontSize:13, display:'block', marginBottom:6 }}>ชื่อบัญชี *</label>
              <input type="text" value={bankEdit.account_name}
                onChange={e => setBankEdit({...bankEdit, account_name:e.target.value})}
                placeholder="นาย ก ข"
                style={{ width:'100%', padding:'10px 14px', borderRadius:8, border:'1px solid #e2e8f0', fontSize:14, boxSizing:'border-box' }} />
            </div>

            <div style={{ marginBottom:12 }}>
              <label style={{ color:'#64748b', fontSize:13, display:'block', marginBottom:6 }}>สาขา (ไม่บังคับ)</label>
              <input type="text" value={bankEdit.branch || ''}
                onChange={e => setBankEdit({...bankEdit, branch:e.target.value})}
                style={{ width:'100%', padding:'10px 14px', borderRadius:8, border:'1px solid #e2e8f0', fontSize:14, boxSizing:'border-box' }} />
            </div>

            <label style={{ display:'flex', alignItems:'center', gap:8, marginBottom:16, cursor:'pointer' }}>
              <input type="checkbox" checked={!!bankEdit.is_primary}
                onChange={e => setBankEdit({...bankEdit, is_primary:e.target.checked})} />
              <span style={{ fontSize:14, color:'#1e293b' }}>⭐ ตั้งเป็นบัญชีหลัก</span>
            </label>

            <div style={{ display:'flex', gap:8, justifyContent:'flex-end' }}>
              <button onClick={() => setBankModal(false)}
                style={{ background:'transparent', color:'#64748b', border:'1px solid #e2e8f0', borderRadius:8, padding:'10px 20px', fontSize:14, cursor:'pointer' }}>ยกเลิก</button>
              <button onClick={saveBankAccount} disabled={bankSaving}
                style={{ background:'#0ea5e9', color:'#fff', border:'none', borderRadius:8, padding:'10px 20px', fontSize:14, fontWeight:600, cursor:'pointer' }}>
                {bankSaving ? 'กำลังบันทึก...' : 'บันทึก'}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Telegram Notice */}
      <div style={{ background: '#f0f9ff', border: '1px solid #bae6fd', borderRadius: 12, padding: 16 }}>
        <p style={{ margin: 0, color: '#0369a1', fontSize: 14 }}>
          📲 การตั้งค่า Telegram แจ้งเตือน ย้ายไปที่เมนู <strong>Telegram</strong> แล้วครับ รองรับหลาย Bot ได้
        </p>
      </div>
    </div>
  );
}
